
import { Row } from "react-bootstrap";
import styled from "styled-components";

export const Container = styled(Row)`
    #tabs-materials .nav-item > .active { 
        color: #6473FF;
        border-bottom: 3px solid #6473FF;
        background-color: transparent;
        border-radius: 0px;
        font-weight: 400;
    }
    
    padding-right: 40px;

`



export const HeaderRow = styled(Row)`
    padding: 8px 46px 2px 16px;
    span  {
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 14px;
        color: #606060;
    }
`

export const CustomRow = styled(Row)`
    background-color: #FFFFFF;
    padding: 8px 46px 8px 16px;
    border-radius: 4px;
    margin-top: 10px;

    span { 
        font-size: 16px;
        color: #606060;
    }


`

